import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import { CounterpartyContact } from "@common/schemas/counterpartyContact.schema";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { formatCounterpartyContactHeadline } from "@components/counterparty/counterpartyBookFormat";

export const CounterpartyContactNameCell = memo(
    ({ row }: CellContext<ViewTableFeatures, CounterpartyContact, string>) => (
        <ViewTableCell>
            {formatCounterpartyContactHeadline(row.original)}
        </ViewTableCell>
    ),
);

CounterpartyContactNameCell.displayName = "CounterpartyContactNameCell";
